module.exports = __webpack_public_path__ + "static/img/demo.c6057301.png";